import qinventory1 from '../images/work/qinventory1.png';
import qinventory2 from '../images/work/qinventory2.png';
import qinventory3 from '../images/work/qinventory3.png';
import portal1 from '../images/work/portal4.png';
import portal2 from '../images/work/portal5.png';
import portal3 from '../images/work/portal6.png';
import acttallergy1 from '../images/work/acttallergy1.png';
import arcadiaridge1 from '../images/work/arcadiaridge1.png';
import arcadiaridge2 from '../images/work/arcadiaridge2.png';
import dreamlinestudios1 from '../images/work/dreamlinestudios1.png';
import elpasospinecenter1 from '../images/work/elpasospinecenter1.png';
import fahrenheit1 from '../images/work/fahrenheit1.png';
import kendallbeard1 from '../images/work/kendallbeard1.png';
import louisianalandbank1 from '../images/work/louisianalandbank1.png';
import txhca1 from '../images/work/txhca1.png';
import sovos1 from '../images/work/sovos1.png';
import sovos2 from '../images/work/sovos2.png';

export default [
  {
    name: 'Q Inventory',
    description: 'Inventory Tracking application built in Meteor.js, MongoDB, and React.js. Companion app built in React Native.',
    description2: 'This project was built for a client who was looking for a way to accurately manage his tools and materials. The unique challenge that he was facing was that he was unable to determine if a material was used, lost, or stolen. Q Inventory solved the problem by showing the difference between actual and expected inventory as well as tracking movement of all materials and tools into and out of the warehouse.',
    description3: 'Q Inventory is built on the Meteor.js framework. It has a MongoDB with oplog tailing, redundancy and daily backups. The front end of the application was built in React.js with SCSS. Materials are scanned in and out of inventory using a companion app, built in React Native, the QR Scanner app scans QR codes and sends data in real time to the Meteor.js Application.',
    img: qinventory1,
    alt: 'q_inventory',
    // demoLink: "https://qrtraqr.com/",
    detailSlug: 'q-inventory',
    images: [qinventory2, qinventory1, qinventory3],
    moreDetail: [
      'Generate an easy-to-read printable list of items due back each day, color coded by team.',
      'Identify and resolve discrepancies between actual and expected item quantities.',
      'Easily generate and print QR codes for any item when restocking.'
    ]
  },
  {
    name: 'Portal',
    description: 'Admin tools for job scheduling, fleet tracking, team performance stats, and profitability',
    img: portal2,
    alt: 'portal',
    // demoLink: "http://portal.element7concrete.com/",
    detailSlug: 'portal',
    images: [portal1, portal2, portal3],
    moreDetail: [
      'Show team performance at a glance.',
      'Measure performance versus expected.',
      'Automatically generate mobilization and labor costs using GPS.'
    ]
  },
  {
    name: 'License Renewal App',
    description: 'Tool used for automating renewal of liquor licenses. Technology used: React, Redux, Redux-Thunk',
    img: sovos2,
    alt: 'sovos_license_renewals',
    detailSlug: 'license-renewals',
    description2: 'While working at Sovos, I was in charge of development a user interface as a replacement for a legacy interface which was built years ago using Backbone.I was the only person on the team who had experience with React and functional development, so I was tasked with working with a Back End Developer to both bring him up to speed in modern React development methodology, and improvise on the design since we had only been supplied with a rough mockup. We were able to accomplish this task and my partner was able to walk away with confidence in his React development abilities.',
    description3: 'Technologies used: React, Node.js, SCSS, Webpack, Jest, React-DND, and C#.'
  },
  {
    name: 'ACTT Allergy',
    description: 'Wordpress, SCSS, HTML5, and Javascript',
    img: acttallergy1,
    alt: 'actt_allergy',
    viewLink: "https://www.acttallergy.com/"
  },
  {
    name: 'Arcadia Ridge',
    description: 'Wordpress, JQuery, SCSS, and Javascript',
    img: arcadiaridge1,
    alt: 'arcadiaridge',
    viewLink: "https://arcadiaridgeliving.com/"
  },
  {
    name: 'Dreamline Studios',
    description: 'React, React Router, Node.js, MongoDB',
    img: dreamlinestudios1,
    alt: 'dreamline',
    viewLink: "https://dreamlinestudios.com/"
  },
  {
    name: 'El Paso Spine Center',
    description: 'Wordpress, SCSS, HTML5',
    img: elpasospinecenter1,
    alt: 'elpasospinecenter',
    viewLink: "http://elpasospinecenter.com/"
  },
  {
    name: 'Fahrenheit.io',
    description: 'Wordpress, SCSS, HTML5, JQuery',
    img: fahrenheit1,
    alt: 'fahrenheit',
    viewLink: "https://fahrenheit.io/"
  },
  {
    name: 'KendallBeard.com',
    description: 'Wordpress, SCSS, HTML5, JQuery',
    img: kendallbeard1,
    alt: 'kendall_beard',
    viewLink: "http://kendallbeard.com/"
  },
  // {
  //   name: 'Louisiana Land Bank',
  //   description: 'Wordpress, SCSS, HTML5, JQuery',
  //   img: louisianalandbank1,
  //   alt: 'louisianalandbank',
  //   viewLink: "http://louisianalandbank.com/"
  // },
  {
    name: 'Texas Healthcare Association',
    description: 'Wordpress, SCSS, HTML5, JQuery',
    img: txhca1,
    alt: 'txhca',
    viewLink: "https://txhca.com/"
  },
];


// WEBPACK FOOTER //
// ./src/assets/data/project_data.js